import {RootState} from "../../store";
import {useDispatch, useSelector} from "react-redux";
import {selectStore} from "../../store/selector";
import {useTranslation} from "react-i18next";
import {createSearchParams, generatePath, useNavigate} from "react-router-dom";
import {InnerTabs, MyBreadcrumb, MyText, OuterTabs} from "../../components";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Col, List, Row} from "antd";
import {FORM_FORM_TYPE, PLANS_TYPES, ROUTE_PATH} from "../../constants";
import {getLibraryAction} from "../../store/pages/library/actions";
import {CardItem} from "../Journal/index.styles";

const TYPES = {
  [FORM_FORM_TYPE.MATERIALS]: '1',
  [FORM_FORM_TYPE.TASKS]: '2',
  [FORM_FORM_TYPE.TESTS]: '3',
}

export const Library = () => {
  const {t} = useTranslation("common")
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [currentOuterType, setCurrentOuterType] = useState<string>(TYPES[FORM_FORM_TYPE.MATERIALS])
  const [currentInnerType, setCurrentInnerType] = useState<string>(PLANS_TYPES.PRIVATE)

  const {
    library: {library: libraryState},
  }: RootState = useSelector(selectStore)

  const header = {
    [TYPES[FORM_FORM_TYPE.MATERIALS]]: 'Мои материалы',
    [TYPES[FORM_FORM_TYPE.TASKS]]: 'Мои задания',
    [TYPES[FORM_FORM_TYPE.TESTS]]: 'Мои тесты',
  }

  const handleClickListItem = (obj: any) => {
    const path = {
      pathname: generatePath(ROUTE_PATH.LIBRARY_CURRENT, {subjectId: obj.id}),
      search: createSearchParams({
        type: currentOuterType,
        caption: obj.caption,
        innerType: currentInnerType
      }).toString()
    }

    navigate(path);
  }

  const content = useMemo(() => {
    return (
      <List
        loading={libraryState.loading}
        dataSource={libraryState.data || []}
        rowKey={(record: any) => record.id}
        style={{width: '100%'}}
        header={(
          <MyText style={{paddingLeft: 16}} size={24} weight={500}>
            {header[currentOuterType]}
          </MyText>
        )}
        renderItem={(listItem: any) => {
          return (
            <List.Item style={{padding: 0}}>
              <CardItem style={{width: '100%'}} onClick={() => handleClickListItem(listItem)}>
                <MyText size={20} weight={400}>
                  {listItem?.caption}
                </MyText>
              </CardItem>
            </List.Item>
          )
        }}
      />
    )
  }, [libraryState])

  const innerTabs = [
    {
      key: PLANS_TYPES.PRIVATE,
      label: t('private'),
      children: content
    },
    {
      key: PLANS_TYPES.PUBLIC,
      label: t('public'),
      children: content
    },
  ]

  const outerTabs = [
    {
      key: TYPES[FORM_FORM_TYPE.MATERIALS],
      label: t('materials'),
      children: (
        <InnerTabs items={innerTabs} onTabClick={(key) => handleCurrentInnerType(key)} activeKey={currentInnerType}/>
      )
    },
    {
      key: TYPES[FORM_FORM_TYPE.TASKS],
      label: t('tasks'),
      children: (
        <InnerTabs items={innerTabs} onTabClick={(key) => handleCurrentInnerType(key)} activeKey={currentInnerType}/>
      )
    },
    {
      key: TYPES[FORM_FORM_TYPE.TESTS],
      label: t('tests'),
      children: (
        <InnerTabs items={innerTabs} onTabClick={(key) => handleCurrentInnerType(key)} activeKey={currentInnerType}/>
      )
    }
  ]

  const handleCurrentOuterType = (value: string) => {
    setCurrentOuterType(value)
    getLibraryList(value, currentInnerType)
  }

  const handleCurrentInnerType = (value: string) => {
    setCurrentInnerType(value)
    getLibraryList(currentOuterType, value)
  }

  const getLibraryList = (outerType: string, innerType: string) => {
    let params = {
      stype: outerType,
      ...(innerType === PLANS_TYPES.PUBLIC ? {is_shared: 1} : {}),
    }

    dispatch(getLibraryAction(params))
  }

  useEffect(() => {
    getLibraryList(currentOuterType, currentInnerType)
  }, [])

  return (
    <>
      <MyBreadcrumb title={'Библиотека'}/>

      <Row justify='center'>
        <Col span={20}>
          <Row>
            <Col span={24}>
              <OuterTabs items={outerTabs} onTabClick={(key: any) => handleCurrentOuterType(key)}
                         activeKey={currentOuterType}/>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}
